window.adev = window.adev || {};

(function ($) {
    "use strict";

    window.adev.adevFeaturedCollection = {
        init() {
            $('[data-adev-featured-collection="wrap"]:not(.adev-init)').each(function () {
                const $this = $(this);

                const items = $this.find('[data-adev-featured-collection="items"]:not(.slick-initialized)');
                if (items.length === 0) {
                    return;
                }

                items.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    infinite: Shopify.designMode ? false : true,
                    swipeToSlide: true,
                    // arrow svg
                    prevArrow: '<button type="button" class="adev-fc__slick-arrow adev-fc__slick-arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 6l-6 6l6 6"/></svg></button>',
                    nextArrow: '<button type="button" class="adev-fc__slick-arrow adev-fc__slick-arrow-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 6l6 6l-6 6"/></svg></button>',
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                arrows: true,
                                infinite: false,
                            }
                        }
                    ]
                });

                $this.addClass('adev-init');
            });
        }
    };

    window.adev.adevFeaturedCollection.init();

    if (Shopify.designMode) {
        $(document).on('shopify:section:load', function (e) {
            if (e.target.id === 'adev-featured-collection') {
                window.adev.adevFeaturedCollection.init();
            }
        });
    }
    
})(jQuery);